// extracted by mini-css-extract-plugin
export default {"Container":"WhoWeAre_Container__o95GM","ContainerRTL":"WhoWeAre_ContainerRTL__rQffj","image":"WhoWeAre_image__t0c40"};